export const actions = {
    FETCH_PLUGIN_LIST: "FETCH_PLUGIN_LIST",
    CALL_PLUGIN_ACTION: "CALL_PLUGIN_ACTION",
};

export const initialState = {
    list: [],
};

export default (state = initialState, { type, data }) => {
    switch (type) {
        case actions.FETCH_PLUGIN_LIST: {
            return {
                ...state,
                list: data,
            };
        }
        default:
            return state;
    }
};
